import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../Vas';

import { ExtendedButton,TextField,MessageBox,SelectField } from 'component-lib';
import { CurrencyConverter,DateTimeHelper,CheckValues } from 'utils-lib';
import { RequestAjaxClass, ContractsModel,ContractDetailsModel, DocumentsModel } from 'models-lib';

var moment = require('moment');
moment().format();

var cancelationReason;
var downloadClicked = false;

class ContractCancel extends Component
{
    constructor(props)
    {
        super(props);
        this.state= {};
        this.Contract = JSON.parse(localStorage.getItem('contract'));
        this.ContractId = props.match.params.ContractId;
        this.CustomerId = props.match.params.CustomerId;
        this.CustomerName = props.match.params.CustomerName;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this],null,this.Request);
        this.ContractDetailsModel = new ContractDetailsModel([this]);
        this.DocumentsModel = new DocumentsModel([this],null,this.Request2);
    }

    componentDidMount(){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      this.Request2.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      this.ContractDetailsModel.SetRequest(this.Request);
      this.ContractDetailsModel.GetContractDetailsByContractId(this.ContractId);

      this.showDocumentDownloadButton();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "ContractDetails"){
          $("#LoadingIcon").removeClass().addClass('hide');
          if (this.ContractDetailsModel.Contract)
          {
            if(this.ContractDetailsModel.Contract.Id && this.ContractDetailsModel.Contract.DateFrom && this.ContractDetailsModel.Contract.DateTo){
              me.setState({
                Id: this.ContractDetailsModel.Contract.Id,
                DateFrom: DateTimeHelper.StringToDate(this.ContractDetailsModel.Contract.DateFrom,false,localStorage.getItem('vas_language')),
                DateTo:DateTimeHelper.StringToDate(this.ContractDetailsModel.Contract.DateTo,false,localStorage.getItem('vas_language'))
              },()=>{
                let date = moment();
                if (me.state.DateFrom){
                  if (me.state.DateFrom.isAfter(date) === true){
                    date = me.state.DateFrom;
                  }
                }
                
                let min = me.getCancelDay(date);
                let endeArr = [{ Key:DateTimeHelper.FormatToShortDateString(min),Display: DateTimeHelper.FormatToShortDateString(min) }];
                let monthEnd = moment([min.year(),min.month(),DateTimeHelper.GetLastDayOfMonth(min.month(),min.year())]);
                let numberOfMonth = Vas.Config.NumberOfTerminationMonth;

                if(DateTimeHelper.FormatToShortDateString(me.state.DateTo) == "01.01.0001" || DateTimeHelper.FormatToShortDateString(me.state.DateTo) == ""){

                  for(let i = 0; i < numberOfMonth; i++){
                    monthEnd.add(1,'months');
                    monthEnd = moment([monthEnd.year(),monthEnd.month(),DateTimeHelper.GetLastDayOfMonth(monthEnd.month(),monthEnd.year())]);
                    endeArr.push({ Key: DateTimeHelper.FormatToShortDateString(monthEnd),Display: DateTimeHelper.FormatToShortDateString(monthEnd) });
                  }                
                } else {
                  while (monthEnd.isSameOrBefore(me.state.DateTo,'day') === true){
                    if (monthEnd.isAfter(min)=== true){
                        endeArr.push({ Key: DateTimeHelper.FormatToShortDateString(monthEnd),Display: DateTimeHelper.FormatToShortDateString(monthEnd) });
                    }
  
                    monthEnd.add(1,'months');
                    monthEnd = moment([monthEnd.year(),monthEnd.month(),DateTimeHelper.GetLastDayOfMonth(monthEnd.month(),monthEnd.year())]);
                  }
                }
                
                me.refs.contractEnd2.setState({ Data:endeArr });
              });
            }
          }
          this.ContractsModel.SetRequest(this.Request);
          this.ContractsModel.GetCancelationReasons();
        }
        else if(observer === "CancelationReasons"){
            let result = this.ContractsModel.CancelationReasons;
            let reasons = [];
            for (let i = 0; i< result.length; i++){
                let reason = { Key:result[i].Id, Display: result[i].Description };
                reasons.push(reason);
            }
            if (reasons.length === 1){
              me.setState({ Reason:result[0].Id });
            }
            me.refs.CancelationReasons.setState({ Data:reasons });
            $("#LoadingIcon").removeClass().addClass('hide');
        }
        else if(observer === "CancelationCosts"){
          $("#LoadingIcon").removeClass().addClass('hide');
          if (this.ContractsModel.CancelationCosts[0]){
              let result = this.ContractsModel.CancelationCosts[0];
              $('#ContractEnd2').val(DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(result.ContractEnd,true,localStorage.getItem('vas_language'))));
              $('#Costs').val(CurrencyConverter.Cast(Math.abs(result.AdditionalPayment),localStorage.getItem('vas_language'),2));
              if (!me.state.MinDate){
                  me.setState({ MinDate:DateTimeHelper.StringToDate(result.ContractEnd,true,localStorage.getItem('vas_language')) }); 
              }
          }
        }
        else if( observer === "ContractCancelation"){
          if(this.CustomerId !== undefined){
            Vas.GetView("ContractCancelSuccessContractCard",{CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName},true);
          } else {
            Vas.GetView("ContractCancelSuccess",null,true);
          }
          
          $("#LoadingIcon").removeClass().addClass('hide');
        }

        //Hier das Dokument runterladen, Download nur, wenn der Downloadbutton gedrückt wurde
        if(me.DocumentsModel.Documents.length > 0 && downloadClicked)
        {

          //Das Ergebnis ist ein Bytestream und der MIME-Type des Dokuments
          var fileInformationArray = me.DocumentsModel.base64ToArrayBuffer(me.DocumentsModel.Documents[0],me);

          var sampleArr = fileInformationArray[0];

          var fileType = fileInformationArray[1];

          me.DocumentsModel.saveByteArray(sampleArr,"Kündigungsdokument." + fileType);
          
          downloadClicked = false;
        }

      });
    }

    Close(){
      if(this.CustomerId !== undefined){
        Vas.GetView("ContractCardContractData",{ Id:this.ContractId, CustomerId: this.CustomerId, CustomerName: this.CustomerName },true);
      } else {
        if(localStorage.getItem('vas_role') !== '1'){
          Vas.GetView("Contracts",{All:true},true);
        }else{
          Vas.GetView("Contracts",{All:false},true);
        }
      }
    }

    getCancelDay(cur){
      let date = cur;
      let day = date.date();
      let lastDay = date.daysInMonth();
      let cancelDate = moment();
      
      if (date.isSame(cancelDate,'month')=== true){

        
        if(localStorage.getItem('vas_role') == '1'){
          cancelDate = moment([date.year(),date.month(),lastDay])
        }else{
          if (day >= Vas.Config.CancelationDeadline){//Kündigungsfrist nicht eingehalten
            cancelDate = date.add(1,'month');
            cancelDate = moment([cancelDate.year(),cancelDate.month(),cancelDate.daysInMonth()]);
          } else {//Kündigungsfrist von X Tagen eingehalten (letzter Tag des aktuellen Monats minus Vas.Config.DaysForCancelationCurrentMonth)
            cancelDate = moment([date.year(),date.month(),lastDay]);
          }
        }
      } else {
        cancelDate = moment([date.year(),date.month(),lastDay]);
      }
      return cancelDate;
    }

    getCostsCancelation(){

        $("#LoadingIcon").removeClass().addClass('loaderSmall');

        if (document.getElementById("CancelationReasons").selectedIndex > 0 && document.getElementById("ContractEnd2").selectedIndex > 0){

            let cur = '';
            let date = moment();
            if (document.getElementById("ContractEnd2").selectedIndex > 0){
              
               cur = DateTimeHelper.StringToDate(document.getElementById("ContractEnd2").value,false,localStorage.getItem('vas_language'));
               date = cur.format('YYYY-MM-DD T 00:00:00');
            }
            
            this.Request.setErrorHandler((error)=>{
              $("#LoadingIcon").removeClass().addClass('hide');
              document.getElementById("ContractEnd2").selectedIndex = 0;
              $('#Costs').val('');
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={error.responseJSON.Description} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            });

            this.ContractsModel.GetCancelationCosts(this.ContractId,this.state.Reason,date);

        } else {
            $("#LoadingIcon").removeClass().addClass('hide');
        }

        this.showDocumentDownloadButton();
    }

    Cancel(){
      
      if(cancelationReason !== undefined && cancelationReason.FlagDocumentNeeded && cancelationReason.DocumentAvailable){

        this.DocumentsModel.GetDocumentById(cancelationReason.IdDocument);

        downloadClicked = true;

      } else if ($('#ContractEnd2').val().length > 0 && document.getElementById('CancelationReasons').selectedIndex > 0){

        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.refs.btoDone.setState({ usable:false });
        let cur = DateTimeHelper.StringToDate($('#ContractEnd2').val(),false,localStorage.getItem('vas_language'));
        let date = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");

        this.ContractsModel.SetRequest(this.Request);
        this.Request.setErrorHandler(()=>{
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Message={Vas.Resources.Labels["CancelationNoSuccess"]}
            Title={Vas.Resources.Titles["Note"]} />, document.getElementById('messageContainer'));   
          $("#LoadingIcon").removeClass().addClass('hide');
          
        })
        this.ContractsModel.ContractCancelation(this.Contract.Id,this.state.Reason,date);

    } else {
        let docs=document.querySelectorAll('select,input');
        let docRefs = this.refs;
        CheckValues.checkAllFields(docs,docRefs,"");
        ReactDOM.render(<MessageBox
          Message={Vas.Resources.Labels["NotAllFields"]}
          Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
    }
    }

    showDocumentDownloadButton(){//Methode um die Buttons für die Vertragskündigung bzw. den Dokumentendownload ein bzw. auszublenden

      cancelationReason = this.ContractsModel.CancelationReasons.find(r => r.Id === this.state.Reason);

      //Wenn Dokument vorhanden, dann Anzeige Button für Dokumentendownload statt Button für Vertragskündigung

      if(cancelationReason !== undefined && cancelationReason.FlagDocumentNeeded && cancelationReason.DocumentAvailable){
        $('#DateCalcelation').removeClass().addClass('hide');
        $('#CostsCancelation').removeClass().addClass('hide');
        $('#CancelationDocumentHint').removeClass('hide').addClass('display');

        document.getElementById("Cancel").innerHTML = Vas.Resources.Labels["Download"];

      }
      else{
        $('#DateCalcelation').removeClass().addClass('display');
        $('#CostsCancelation').removeClass().addClass('display');
        $('#CancelationDocumentHint').removeClass('display').addClass('hide');

        document.getElementById("Cancel").innerHTML = Vas.Resources.Labels["ContractCancel"];
      }
    }

    render()
    {
        return (
        <div className={'form'}>
          <table>
            <thead>
              <tr>
                <th>{Vas.Resources.Labels["ContractCancel"]}</th>
                <th><div 
                  id={"LoadingIcon"} 
                  className={'hide'}></div></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>
                  <SelectField 
                    AppURL={Vas.ApplicationUrl} 
                    Id={"CancelationReasons"} 
                    ref={"CancelationReasons"} 
                    Width={270} 
                    IsRequired={true} 
                    Label={Vas.Resources.Labels["CancelationReason"]}
                    LabelHeight={'16px'}
                    OnChange={()=>{
                      if (document.getElementById("CancelationReasons").selectedIndex === 0 && this.refs.CancelationReasons.state.Data.length === 1) {
                        document.getElementById("CancelationReasons").selectedIndex = 1; 
                      }
                      this.setState({ Reason:$('#CancelationReasons').val() },()=>{this.getCostsCancelation();});}} 
                    /> 
                </td>
              </tr>
              <tr id={'DateCalcelation'}>
                <td style={{display:'table'}}>
                  <SelectField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"contractEnd2"}
                    IsRequired={true}
                    Id={"ContractEnd2"} 
                    Label={Vas.Resources.Labels["ContractEnd"]}
                    LabelHeight={'16px'}
                    OnChange={()=>{this.setState({ CancelationDate: $("#ContractEnd2").val() },()=>{this.getCostsCancelation();}); }}
                     />
                </td>
              </tr>
              <tr id={'CostsCancelation'}>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  ref={"Costs"} 
                  Id="Costs" 
                  Editable={false} 
                  Label={Vas.Resources.Labels["CancelationCosts"]} />
                </td>
              </tr>
              <tr id={'CancelationDocumentHint'}>
                <td>
                  <div className={'DownloadCancelationDocumentHint'}>
                    <br/>
                    {Vas.Resources.Labels["DownloadCancelationDocumentHint1"]} <br/><br/>
                    
                    <div style={{ fontStyle: 'italic', textAlign: 'center', width: '300px' }}>{Vas.Resources.Labels["Address"]}</div> <br/>
                    
                    {Vas.Resources.Labels["DownloadCancelationDocumentHint2"]} <br/><br/>
                  </div>
                </td>
              </tr>
              <tr>
                <td >
                  <br />
                  <ExtendedButton
                    Id={'Abort'}
                    Usable={true} 
                    Text={Vas.Resources.Labels["Cancel"]} 
                    Float={'left'} 
                    OnClick={()=>{ this.Close();}} 
                    Width={130}/>
                  <ExtendedButton
                    Id={'Cancel'}
                    Usable={true} 
                    ref={"btoDone"} 
                    Text={Vas.Resources.Labels["ContractCancel"]} 
                    Float={'left'}  
                    OnClick={()=>{ this.Cancel();}} 
                    Width={130}/>
                </td>
                <td>   
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        );
  }
}
export default ContractCancel;
